import { Navigate } from 'react-router-dom'
import { STAFF_ROUTE } from '../../app/router/routes'

export default function AdminsPage() {
    return <Navigate to={STAFF_ROUTE.path} replace />
}
